import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, Download, FileText } from "lucide-react";

export const Route = createFileRoute("/education/writing/templates")({
  head: () => ({
    meta: [
      { title: "Legal Writing Templates — Opinions, Case Notes, Memos | Nkadimeng Danny" },
      {
        name: "description",
        content:
          "Free RTF templates for South African law students: legal opinions, case notes, memoranda and assignment structure. Open in Word, Google Docs or Pages.",
      },
      { property: "og:title", content: "Legal Writing Templates" },
    ],
  }),
  component: TemplatesPage,
});

const TEMPLATES = [
  {
    file: "/templates/legal-opinion.rtf",
    title: "Legal Opinion",
    body: "Instructions → facts → questions → applicable law → opinion → recommendations. The structure used in practice for written advice.",
  },
  {
    file: "/templates/case-note.rtf",
    title: "Case Note",
    body: "Introduction, facts, issues, judgment, ratio decidendi, order, critical analysis and conclusion — for academic and module case notes.",
  },
  {
    file: "/templates/memorandum.rtf",
    title: "Internal Legal Memorandum",
    body: "Question presented, short answer, facts, applicable law, IRAC analysis and recommendations. For office memos and research advice.",
  },
  {
    file: "/templates/assignment-structure.rtf",
    title: "Law Assignment Structure",
    body: "Introduction → body (with arguments and counter-argument) → conclusion → bibliography, plus a submission checklist.",
  },
  {
    file: "/templates/research-memorandum.rtf",
    title: "Research Memorandum",
    body: "Heading, question, summary, jurisdictional research notes and authorities — for legal research assignments.",
  },
  {
    file: "/templates/heads-of-argument.rtf",
    title: "Heads of Argument",
    body: "Court submission template: index, introduction, issues, submissions, prayers and list of authorities.",
  },
];

function TemplatesPage() {
  return (
    <div className="container-narrow py-10">
      <Link to="/education/writing" className="inline-flex items-center gap-1 text-xs text-navy/70 hover:text-navy">
        <ArrowLeft className="h-3.5 w-3.5" /> Back to Writing Academy
      </Link>
      <header className="mt-4">
        <h1 className="font-display text-3xl text-navy">Writing Templates</h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Free RTF templates you can open in Microsoft Word, Google Docs or Apple Pages. Replace the
          square-bracket placeholders with your own content. Verify every citation against the
          primary source before submission.
        </p>
      </header>

      <ul className="mt-8 grid gap-4 md:grid-cols-2">
        {TEMPLATES.map((t) => (
          <li key={t.file} className="rounded-lg border border-input bg-card p-5">
            <div className="flex items-start gap-3">
              <span className="rounded-md bg-navy/5 p-2 text-navy">
                <FileText className="h-5 w-5" />
              </span>
              <div className="flex-1">
                <h2 className="font-display text-lg text-navy">{t.title}</h2>
                <p className="mt-1 text-sm text-muted-foreground">{t.body}</p>
                <a
                  href={t.file}
                  download
                  className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-navy hover:underline"
                >
                  <Download className="h-4 w-4" /> Download .rtf
                </a>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
